import { useTranslation } from 'react-i18next';
const prefix = 'studentManagement.tabs.studyPlans';
export function useTexts() {
  const { t } = useTranslation();
  return {
    tabTitle: t(`${prefix}.tabTitle`),
    sectionTitle: t(`${prefix}.sectionTitle`),
    noResults: t(`${prefix}.noResults`),
    table: {
      studyPlan: t(`${prefix}.table.studyPlan`),
      periodEntry: t(`${prefix}.table.periodEntry`),
      admissionVia: t(`${prefix}.table.admissionVia`),
    },
  };
}
